import { render } from "./Compras.vue?vue&type=template&id=5fe3fbaf&scoped=true"
import script from "./Compras.vue?vue&type=script&lang=js"
export * from "./Compras.vue?vue&type=script&lang=js"

import "./Compras.vue?vue&type=style&index=0&id=5fe3fbaf&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe3fbaf"]])

export default __exports__